// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SORT_COMPLAINTS_SHORT = "Po\u010det nahl\u00e1\u0161eni";
export const BZ2_SORT_COMPLAINT_TIME_SHORT = "Nahl\u00e1\u0161en\u00e9";
export const BZ2_SORT_CREATION = "Posledn\u00ed p\u0159idan\u00e9";
export const BZ2_SORT_PRICE = "Cena: nejlevn\u011bj\u0161\u00ed";
export const BZ2_SORT_PRICE_DESC = "Cena: nejdra\u017e\u0161\u00ed";
export const BZ2_SORT_SCORE = "Popul\u00e1rn\u00ed";
export const BZ2_SORT_SCORE_NEW = "Relevantn\u00ed";
export const BZ2_SORT_UPDATED = "Aktualizov\u00e1no";
export const BZ2_SORT_WATCHDOG = "Ulo\u017een\u00e9 hled\u00e1n\u00ed";
export const BZ2_SORT_WISHLIST = "Ulo\u017een\u00e9";
